import React from 'react';
import ReactDOM from 'react-dom'
import Modal from '../../App/Modal'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as Actions from '../../../actions/User/Credit';

class Component extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      selectedCardId: null
    };
  };

  componentWillMount = () => {
    this.props.getCreditCardInfo()
  }

  openModal = (id) => {
    this.setState({openModal: true,selectedCardId: id})
  }

  closeModal = () => {
    this.setState({openModal: false})
  }

  render = () => {

    let modal, cards
    modal = (
      <Modal
        okClickHandler={() => this.props.deleteCreditCard(this.state.selectedCardId)}
        okText='削除する'
        headerTitle='カード情報を削除しますか？'
        isOpen={this.state.openModal}
        closeModal={this.closeModal}
      >
        <p>有効期限切れのカードのみ削除することが出来ます。</p>
      </Modal>
    )

    if (!!this.props.CreditCard.usersCards) {
      cards = this.props.CreditCard.usersCards.map((card) => {
        let activeText,deleteCardBtn
        if (card.is_active) {
          activeText = '有効'
          deleteCardBtn = (
            <span className='btn btn-danger disabled'>カード情報を削除</span>
          )
        } else {
          activeText = '無効'
          deleteCardBtn = (
            <span className='btn btn-danger' onClick={() => { this.openModal(card.id)}}>カード情報を削除</span>
          )
        }
        return (
          <li className='card-list cards'>
            <i className="material-icons">credit_card</i>
            <p>
              <span>{card.brand}</span>
              <span className='ml10 d-inline-block'>**** **** **** {card.last4}</span>
              <span className='ml10 notice-text'>（{activeText}）</span>
            </p>
            {deleteCardBtn}
          </li>
        )
      })
    } else {
      cards = (
        <li>登録済みのカードはありません</li>
      )
    }

    return (
      <div className=''>
        {ReactDOM.createPortal(modal, document.getElementById('dialogSpace'))}
        <h2 className='mt0 headline'>クレジットカード情報</h2>
        <ul>
          {cards}
        </ul>
      </div>
    )
  }
}



const mapStateToProps = (state) => {
  return state
};

const mapDispatchToProps = (dispatch) => (bindActionCreators(Actions, dispatch));


const Container = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Component);

export default withRouter(Container);


// WEBPACK FOOTER //
// ./src/components/User/Credit/CreditInfo.jsx